import React, { Component } from 'react';
import { Table, Button, Alert } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, CardTitle, CardText, Row, Col, Spinner } from 'reactstrap';
import { Collapse, CardBody, Card, CardHeader, Input, Badge, UncontrolledCollapse } from 'reactstrap';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa';
import { BiCaretDown, BiCaretRight } from 'react-icons/bi';
/*import history from "../history";*/
import './NavMenu.css';
import url from "./variables/url.js";
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import LoteActividades from './LoteActividades';
import LoteActividadesPorTipo from './LoteActividadesPorTipo';
import { AppContext } from '../AppContext';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;

export class ActExtraEstudiante extends Component {
    static displayName = ActExtraEstudiante.name;

    constructor(props) {
        super(props);
        this.state = {
            status: 0,
            activeTab: 1,
            loading: true,
            total: 0,            
            categorias: [],
            tipos: [],
            idUser: 0,
            collapse: 1,
            dropdownOpen: false,
            actividades: [],            
            currentActividades: [],
            currentPage: null,
            totalPages: null,
            isOpen: [],
            actividades1: [],            
            actividades2: [],            
            actividades3: [],            
            actividades4: [],            
            actividades5: [],            
            actividades6: [],
           
        };

        /*this.handleEdit = this.handleEdit.bind(this);*/
        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this);
        this.toggleDD = this.toggleDD.bind(this);
        this.newActEst = this.newActEst.bind(this);
        this.changeTap = this.changeTap.bind(this);
        this.onChangeTipo = this.onChangeTipo.bind(this);
        this.handleIsOpen = this.handleIsOpen.bind(this);
    }

    componentDidMount() {
        let user = this.context;
        //this.setState({ currentUser: user });
        //console.log('user', this.state.currentUser.idpersona);
        this.populateInfoData();
        if (user != null)
            this.populateActividades(user.idpersona);
    }

    componentDidUpdate(prevProps, prevState) {
        let user = this.context;
        if (user != null && prevState.actividades.length !== this.state.actividades.length) {
            this.populateActividades(user.idpersona);
        }
    }

    onPageChanged = data => {
        const { actividades } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const currentActividades = actividades.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentActividades, totalPages });
    }

    onChangeTipo(e) {
        //console.log('Cambio Tipo');
        //console.log(e.target.value);
        var id = e.target.value;
        this.setState({ collapse: id });      
    }

    isEditable(idTipo) {
        const intocable = [1, 20, 21, 33];
        if (intocable.includes(idTipo))
            return false;
        else
            return true;
    }

    renderActividadesTable(actividades, currentActividades, currentPage, totalPages) {
      const currentUser = this.context;
      const { collapse } = this.state;
      
      return (
      <div>
            <h1>Mis Actividades Extracurriculares</h1>

            <Nav pills>
                {this.state.categorias.map(categoria =>
                    <NavItem>
                        <NavLink className="icon-pointer" style={{ fontSize: "0.7vw" }} active={categoria.idaexinsignia === this.state.activeTab} onClick={() => { this.toggle(categoria.idaexinsignia); }}>
                            {categoria.nombre}
                        </NavLink>
                    </NavItem>
                  )}                  
            </Nav>
              <hr />
              <TabContent activeTab={this.state.activeTab}>                  
                {this.state.categorias.map((categoria) =>
                    <><TabPane  tabId={categoria.idaexinsignia}>                        
                        <Alert color="dark">
                            <h4 className="alert-heading">{categoria.nombre}</h4>
                            <p>
                                {categoria.descripcion}
                            </p>                            
                        </Alert>
                        {this.state.tipos.map((tipo) => {
                            if (tipo.categoria == categoria.idaexinsignia || tipo.categoria == 0)
                                return <><Card>
                                    <CardHeader>
                                        <Row>
                                            <Col xs="9" id={'toggler-' + categoria.idaexinsignia + '-' + tipo.idaextipoactividad} className='icon-pointer' onClick={() => this.handleIsOpen('toggler-' + categoria.idaexinsignia + '-' + tipo.idaextipoactividad)}>
                                                {this.state.isOpen.includes('toggler-' + categoria.idaexinsignia + '-' + tipo.idaextipoactividad) ? <BiCaretDown /> : <BiCaretRight />} <strong>{tipo.nombre}</strong>
                                            </Col>
                                            <Col xs="3" style={{ textAlign: 'right', position: 'relative', top: '50%' }}>
                                                {this.isEditable(tipo.idaextipoactividad) ? <Button color="primary" onClick={(id) => this.props.history.push(homepage + 'New-Act/' + categoria.idaexinsignia + '/' + tipo.idaextipoactividad)}><FaPlus /></Button> : <></>}
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <UncontrolledCollapse toggler={'#toggler-' + categoria.idaexinsignia + '-' + tipo.idaextipoactividad}>
                                      <CardBody style={{ padding: 0}}>
                                            <LoteActividadesPorTipo userId={this.state.idUser} tipo={tipo.idaextipoactividad} categoria={categoria.idaexinsignia} editable={this.isEditable(tipo.idaextipoactividad)}/>
                                      </CardBody>
                                    </UncontrolledCollapse>
                                </Card><br /> </>
                            }                            
                         )}                        
                        {/*<CardText>*/}
                        {/*    <div className="form-group row" >*/}
                        {/*        <label className="control-label col-md-2" htmlFor="Name"> A&ntilde;adir Tipo: </label>*/}
                        {/*        <Input className="form-control col-md-8" type="select" onChange={this.onChangeTipo} value={this.state.collapse}>*/}
                        {/*            {this.state.tipos.map(tipo => {*/}
                        {/*                return (categoria.idaexinsignia === tipo.categoria || 0 === tipo.categoria) ?*/}
                        {/*                    <option key={tipo.idaextipoactividad} selected={tipo.idaextipoactividad == this.state.collapse ? true : false} value={tipo.idaextipoactividad}>{tipo.nombre}</option>*/}
                        {/*                    : <></>*/}
                        {/*            }*/}
                        {/*            )}*/}
                        {/*        </Input>*/}
                        {/*        {this.state.tipos.map(tipo =>*/}
                        {/*            <Button className="control-label col-md-2" hidden={tipo.idaextipoactividad == this.state.collapse ? false : true} color="primary" onClick={(id) => this.props.history.push('/New-Act/' + categoria.idaexinsignia + '/' + tipo.idaextipoactividad)}><FaPlus /></Button>*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*</CardText>                                                */}
                        {/*<LoteActividades userId={this.state.idUser} categoria={categoria.idaexinsignia} />*/}

                    </TabPane>                       
                    </>
                )}                                
              </TabContent>             
                           
      </div>
    );
    }

    render() {
        const currentUser = this.context;
        if (currentUser == null) {
            return <><Spinner animation="grow" /></>;
        } else if (currentUser != null && this.state.idUser == 0) {
            this.setState({ idUser: currentUser.idpersona })
            this.populateActividades(currentUser.idpersona);
        }
        let contents = this.state.loading
            ? <><Spinner animation="grow" /></>
            : this.renderActividadesTable(this.state.actividades, this.state.currentActividades, this.state.currentPage, this.state.totalPages);

        return (
            <div>                
                {contents}                
            </div>
        );
    }

    populateActividades(idpersona) {        
            fetch(localBack + '/api/RegistroActividad/GetByEstudiante/' + idpersona, {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status });
                    return response.json();
                })
                .then(data => {
                    //console.log(data.strMensaje);
                    if (data.strEstado == 'S') {
                        this.setState({ actividades: data.objDatos, loading: false, });                        
                    } else {
                        this.setState({ actividades: [], loading: false });
                    }                    
                });
        
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
        
    }
    

    changeTap(cat) {
        const user = this.context;       

        fetch(localBack + '/api/RegistroActividad/GetActByCat/' + user.idpersona + '/' + cat, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: [] });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, total: 1 });                    
                } else {
                    this.setState({ actividades: [], loading: false });
                }
            });
        /*console.log(this.state.actividades);*/
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {
                    /*console.log(data);*/
                    this.setState({
                        categorias: data.objDatos  });
                });

        fetch(localBack + '/api/TipoActividad/GetOnlyActive', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    tipos: data.objDatos                    
                });
            });        
        
    }

    newAct() {
        //console.log('Nueva Actividad');
        /*history.push('/Add-Act');*/        
    }    

    toggle(tab) {
        if (this.state.activeTab !== tab) {            
            this.setState({
                activeTab: tab
            });
        }
    }

    handleIsOpen(id) {        
        let idlist = this.state.isOpen;
        if (idlist.includes(id)) {
            let el = idlist.indexOf(id);
            if (el > -1) {
                idlist.splice(el, 1);
            }
        } else {
            idlist.push(id)
        }
        this.setState({ isOpen: idlist });

        //if (this.state.idsSeleccionadas.length === this.state.actividades.length) {
        //    this.setState({ allselectA: true });
        //} else {
        //    this.setState({ allselectA: false });
        //}
        /*console.log(this.state.idsSeleccionadas); */
    }

    toggleCard(e) {
        let event = e.target.dataset.event;
        this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });               
    }

    toggleDD = (e) => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    newAct() {
        //console.log('Nueva Actividad');
        /*history.push('/Add-Act');*/
    }

    newActEst(categoria, tipo) {
        /*console.log('Nueva Actividad Estudiante');*/
        /*history.push('/New-Act/' + categoria + '/' + tipo);*/
        this.props.history.push(homepage+'New-Act/' + categoria + '/' + tipo);
    }

    //handleEdit(id) {
    //    console.log("Editar " + id);
    //    /*history.replace("/Edit-Act/" + id);*/
    //    this.props.history.push("/Edit-Act/" + id);
    //}

}
ActExtraEstudiante.contextType = AppContext;
/*export default withRouter(ActExtraEstudiante);*/